import React from 'react';
import Footer from '../footer/Footer';
import { connect } from 'react-redux'
import { fetchResults, returnFromResultDetail, fetchEvent, clearResultDetailsState} from '../../actions'
import { Table } from 'semantic-ui-react'
import ReactGA from 'react-ga';
import { GA_TRACKING_RESULTS_DETAILS_PAGE } from '../helpers/AppConsts'

class ResultDetails extends React.Component {
    
  onReturn = (formValues) => {
    this.props.clearResultDetailsState();
    this.props.returnFromResultDetail(); 
  }    
 
  handleClick(e) {
    e.preventDefault();
  }

  componentDidMount(){
      ReactGA.ga('send', 'pageview', GA_TRACKING_RESULTS_DETAILS_PAGE);
      this.props.fetchResults(this.props.match.params.resultId);
      this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_date);
      
  }

  componentWillUnmount(){ 
    this.props.clearResultDetailsState();
  }


  renderGenericHeader = (events) => {
    
    const { 
        event_name: name,
        event_location: location,
        event_day: day,
        event_month: month,
        event_year: year,
        event_results: results
    } = events;

    return (
        <React.Fragment>
            <h2>Rankings for {name +', '+ location}.</h2>
            <h2>Date: {day + '-' + month + '-' +year}</h2>
            <h3> 
            <a href={results} target='_blank' rel='noopener noreferrer'>
                 To view detailed results, including scorecards, click here.
            </a>
            </h3>
            <button className="ui button positive" onClick={this.onReturn}>
            Return
            </button>
        </React.Fragment>
    );
  }


  renderHeader = () => {
    if(this.props.edits.editEvent){
        return (
            this.renderGenericHeader(this.props.edits.editEvent)
        );
    }
    else{
        return (
            <React.Fragment>
                <h2>Loading Results...</h2>
                <button className="ui button primary" onClick={this.onReturn}>
                    Return
                </button>
            </React.Fragment>
        );
    }
  }

  render () {
    if(!this.props.gameResults){
        return (
            <React.Fragment>
                <div className="ui container">
                    {this.renderHeader()}
                </div>
                <Footer/>
            </React.Fragment>
        )
    }
    else{
        return (
            <React.Fragment>
                <div className="ui container">
                    {/* <Divider hidden/> */}
                    {(this.props.edits.editEvent) ? this.renderGenericHeader(this.props.edits.editEvent) : ''}

                    <Table celled striped>
                        <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Names</Table.HeaderCell>
                            <Table.HeaderCell>Rank</Table.HeaderCell>
                            <Table.HeaderCell>Bds</Table.HeaderCell>
                            <Table.HeaderCell>Score</Table.HeaderCell>
                            <Table.HeaderCell>Max</Table.HeaderCell>
                        </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {renderResultsTable(this.props.gameResults)}
                        </Table.Body>
                    </Table>
                  </div>
                <Footer/>
            </React.Fragment>
        )
    }
    }
} 

const isWinnerRow = (rank, names) => { 
   if(rank === '1'){
       return <Table.Cell active>{names}</Table.Cell>
   }
   else {
       return <Table.Cell>{names}</Table.Cell>
   }
};

const renderResultsTable = (results) => results.map((resultRow, index) => {
    const {Rank, Names, Bds, Score, Max} = resultRow;
    return (
        <Table.Row>
            {isWinnerRow(Rank, Names)}
            <Table.Cell>{Rank}</Table.Cell>
            <Table.Cell>{Bds}</Table.Cell>
            <Table.Cell>{Score}</Table.Cell>
            <Table.Cell>{Max}</Table.Cell>
        </Table.Row>
    ) 
});

const mapStateToProps = (state, ownProps) => {
  return {
    gameResults: state.results.results,
    edits: state.edits,
  };  
}

export default connect(mapStateToProps, {fetchResults,returnFromResultDetail, fetchEvent, clearResultDetailsState})(ResultDetails)
